<template>
  <div class="match-layout">
    <score-board :sport="sport" :league="league" :event="event">
      <div class="score-board-table">
        <div class="score-board-table-head">
          <div class="comment">
            <span class="kind-name" v-if="event.kind">{{ event.kind }}</span>
            {{ results.minute ? results.minute : '' }}
            <span class="time-blink" v-if="results.minute">'</span>
            {{ results.comment }}
          </div>
          <div class="right-flex" v-if="results.score">
            <div class="common-score score-cell">{{ $t('live.score') }}</div>
            <div class="flex" v-if="results.score.periods">
              <div class="score-cell" v-for="(p, i) in results.score.periods" :key="i">{{ i + 1 }}</div>
            </div>
            <div class="score-cell" v-if="results.score.yellowCards" :title="$t('live.yellow-cards')">
              <sport-icon medium name="yellow-card" />
            </div>
            <div class="score-cell" v-if="results.score.corners" :title="$t('live.corners')">
              <sport-icon medium name="corner" />
            </div>
            <div
              class="game-score score-cell"
              :title="$t('live.game')"
              v-if="results.points && results.gameNumber">{{ results.gameNumber }}</div>
          </div>
        </div>
        <div class="score-board-table-team">
          <div class="team-name">{{ event.home }}</div>
          <div class="right-flex" v-if="results.score">
            <div class="common-score score-cell">{{ results.score.home }}</div>
            <div class="flex" v-if="results.score.periods">
              <div class="score-cell" v-for="(p, i) in results.score.periods" :key="i">{{ p.home }}</div>
            </div>
            <div class="score-cell" v-if="results.score.yellowCards">{{ results.score.yellowCards.home }}</div>
            <div class="score-cell" v-if="results.score.corners">{{ results.score.corners.home }}</div>
            <div class="game-score score-cell" v-if="results.points">{{ results.points.home }}</div>
            <div class="turn-cell" v-if="results.turn && results.turn === 1">
              <sport-icon medium :name="sport.alias" />
            </div>
          </div>
        </div>
        <div class="score-board-table-team">
          <div class="team-name">{{ event.away }}</div>
          <div class="right-flex" v-if="results.score">
            <div class="common-score score-cell">{{ results.score.away }}</div>
            <div class="flex" v-if="results.score.periods">
              <div class="score-cell" v-for="(p, i) in results.score.periods" :key="i">{{ p.away }}</div>
            </div>
            <div class="score-cell" v-if="results.score.yellowCards">{{ results.score.yellowCards.away }}</div>
            <div class="score-cell" v-if="results.score.corners">{{ results.score.corners.away }}</div>
            <div class="game-score score-cell" v-if="results.points">{{ results.points.away }}</div>
            <div class="turn-cell" v-if="results.turn && results.turn === 2">
              <sport-icon medium :name="sport.alias" />
            </div>
          </div>
        </div>
      </div>
    </score-board>
    <!--market-filter :suite="event.groups" @change="marketGroup = arguments[0]" /-->
    <market-filter v-if="!event.paused" :suite="event.groups" @change="marketGroup = arguments[0]" />
    <span class="search" v-if="!event.paused">
      <input class="head-text" type="text" :placeholder="$t('search.placeholder')" v-model="query" />
    </span>
    <div class="pause" v-if="event.paused">{{ $t('live.paused') }}</div>
    <!--market-filter :suite="event.groups" @change="marketGroup = arguments[0]" /-->
    <!--factor-list :event="event" :periods="periods" :group="marketGroup" :query="query" /-->
    <factor-list :event="event" :periods="periods" :group="marketGroup" :query="query" v-if="periods.length && !event.paused" />
  </div>
</template>

<script>
import SportIcon from '@/components/icons/SportIcon'
import ScoreBoard from '@/components/sports/eventview/ScoreBoard'
import MarketFilter from '@/components/sports/eventview/MarketFilter'
import FactorList from '@/components/sports/eventview/FactorList'
import { mapState } from 'vuex'

export default {
  components: { SportIcon, ScoreBoard, MarketFilter, FactorList },
  computed: {
    ...mapState({
      sport: state => state.live.eventview.sport,
      league: state => state.live.eventview.league,
      event: state => state.live.eventview.event,
      results: state => state.live.eventview.results,
      periods: state => state.live.eventview.periods
    })
  },
  data () {
    return {
      marketGroup: 'a',
      query: ''
    }
  },
  updated () {
    let scrollbar = document.querySelector('#live-event-scrollbar')
    if (!scrollbar) return
    let match = scrollbar.querySelector('.match-layout')
    if (!match) return

    let scrollTop = match.clientHeight - scrollbar.clientHeight
    if (scrollbar.scrollTop > scrollTop) {
      scrollbar.scrollTop = scrollTop
    }
  }
}
</script>

<style scoped>
.match-layout { /* margin: 0 10px; */ margin-right: 10px; }
.score-board-table { background: rgba(255,255,255,0.3); border-radius: 10px; height: 100px; left: 50%; margin: 18px 0 0 -250px; padding: 2px 14px; position: absolute; width: 500px; border: 1px solid hsla(0,0%,100%,.07) !important;}
.score-board-table-head { border-bottom: 1px solid rgba(255, 255, 255, .07); display: flex; height: 24px; line-height: 24px; margin-bottom: 4px; }
.score-board-table-head .comment { color: #713592; }
.score-board-table-head .kind-name { color: #713592; margin-right: 5px; }
.score-board-table-team { display: flex; height: 32px; font-size: 14px; line-height: 32px; }
.score-cell { text-align: center; width: 34px; color: #342d6e; }
.common-score { color: darkorange; margin-left: 10px; }
.game-score { color: #342d6e; margin-right: 7px; }
.turn-cell { margin-top: 1px; width: 16px; }
.pause { width: 100%; text-align: center; height: 50px; line-height: 50px; font-size: 14px; }

.search { float: right; }

input {
    border: none;
    border-radius: 10px;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    width: 145px;
    transition: background .3s;
    color: #231e4a;
    margin-bottom: 0px;
    margin-left: 5px;
    border: 1px solid #713592;
    margin-top: 5px;
}
input:focus::-webkit-input-placeholder { color: transparent; border: none; }
input:focus::-moz-placeholder { color: transparent; border: none; }
input:focus:-moz-placeholder { color: transparent; border: none; }
input:focus:-ms-input-placeholder { color: transparent; border: none; }
input::-webkit-input-placeholder { color: #231e4a; opacity: 1; }
input::-moz-placeholder { color: #231e4a; opacity: 1; }
input:-ms-input-placeholder { color: #231e4a; opacity: 1; }
input:-moz-placeholder { color: #231e4a; opacity: 1; }
</style>



// WEBPACK FOOTER //
// src/components/live/eventview/Event.vue